module.exports = __webpack_public_path__ + "static/media/Dan McCann Headshot.a0e8a691.png";